import { atom } from 'recoil';
import type { Utils } from '@sparrow-marketing/contracts';

import type { FilterConfiguration, FilterState } from './types';

export const HideInActiveState = atom<Utils.DynamicObject<string, boolean>>({
  key: 'hide-inactive-state',
  default: {},
});

export const FilterInputValueState = atom<Utils.DynamicObject<string, string>>({
  key: 'filter-input-value-state',
  default: {},
});

export const IsFilterInputLoaderState = atom<boolean>({
  key: 'is-input-state',
  default: false,
});

export const FilterSourceType = atom<'ads' | 'website' | string>({
  key: 'filter-source-type',
  default: '',
});

export const FilterConfigurationState = atom<FilterConfiguration>({
  key: 'filter-configuration-state',
  default: {
    ads: {
      sourceType: '',
      sourceId: '',
    },
    website: {
      sourceType: '',
      sourceId: '',
    },
  },
});

export const FilterAccountsState = atom<FilterState>({
  key: 'filter-accounts-state',
  default: {},
});

export const SelectedFilterAccountsState = atom<FilterState>({
  key: 'selected-filter-accounts-state',
  default: {},
});
